<template>
  <p class="leading-6 [&:not(:first-child)]:mt-0 text-foreground font-normal text-base ">
    <slot />
  </p>
</template>